import { CheckoutSection } from './CheckoutSection';

interface CommentsSectionProps {
  value: string;
  onChange: (value: string) => void;
}

export function CommentsSection({ value, onChange }: CommentsSectionProps) {
  return (
    <CheckoutSection title="Comments">
      <textarea
        id="comments"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={500}
        rows={3}
        placeholder="Add any notes for the warehouse team (e.g. test order)"
        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
      />
    </CheckoutSection>
  );
}
